import {BaseModel} from './BaseModel';

export interface IOrgModelProps {
    OrganizationId?: string;
    id?: string;
    OrganizationName?: string;
    IsActive?: boolean;
    Link?: string;
    Filename?: string;
    CreatedAt?: string;
    FilePath?: string;
    Category?: [];
    SubCategory?: [];
    OrgImage?: string;
    OrgPicFile?: File;
}

export class OrgModel extends BaseModel<IOrgModelProps> {
    constructor(props: IOrgModelProps) {
        super(props);
    }

    public static get(id: string) {
        return OrgModel.getSingleInstance<IOrgModelProps>(id);
    }

    public static list() {
        return OrgModel.listAll<IOrgModelProps>();
    }

    public static resource: string = 'org';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/OrgModel.ts